module.exports = __webpack_public_path__ + "static/media/ide.df6e84db.svg";